<template>
  <VueSplitter
    :margin="30"
    :horizontal="horizontal"
    style="display: flex; height:  100%; overflow: hidden "
  >
    <Groups
      slot="left-pane"
      @choice="choice"
    />
    <GroupInfo
      slot="right-pane"
      :list="cur_list"
    />
  </VueSplitter>
</template>

<script>
import GroupInfo from './Info/Index.vue'
import Groups from './Tree/Index.vue'
import VueSplitter from '@rmp135/vue-splitter'
export default {
  name: 'CustomDeviceList',
  components: {
    GroupInfo,
    VueSplitter,
    Groups
  },
  data () {
    return {
      new_group: '',
      cur_list: {},
    }
  },
  computed:{
    horizontal(){
      return document.documentElement.clientWidth <= 768;
    }
  },
  methods: {
    choice (list) {
      this.cur_list = list
    },
  }
}
</script>
